import React from "react";
import { isMobileOnly } from "react-device-detect";
import { Outlet } from "react-router-dom";

import MobileAppPromo from "../../components/mobile-app-promo/MobileAppPromo";
import MainMenu from "../../components/sidebar/mainMenu/MainMenu";
import NotificationPermissionRequest from "../../components/shared/NotificationPermissionRequest/NotificationPermissionRequest";
import styles from "./layout.module.scss";

const LayoutMain = ({ children }) => {
  if (isMobileOnly) {
    return <MobileAppPromo />;
  }

  return (
    <div className={styles.wrapper}>
      <MainMenu />
      <main className={styles.content}>
        <NotificationPermissionRequest />
        {children}
        <Outlet />
      </main>
    </div>
  );
};

export default LayoutMain;
